import { createListFilters, IOption } from '../../../../../components'

export type AtendimentosNaoFaturadosFilters = {
  empresa?: IOption<number>
  mes?: IOption<string>
  ano?: IOption<number>
  paciente: string
  protocolo: string
  especialidade?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } =
  createListFilters<AtendimentosNaoFaturadosFilters>({
    empresa: undefined,
    mes: undefined,
    ano: undefined,
    paciente: '',
    protocolo: '',
    especialidade: undefined,
  })
